import axios from "@/util/axios";
import { assertId, assertData } from "./restApi";
const addressUrl = `api/shopping/address/`;

const getCacheBuster = () => Date.now().toString();

export const fetchAddressList = async () => {
  try {
    const response = await axios.get(`${addressUrl}?_=${getCacheBuster()}`);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};

export const addAddress = async (address) => {
  try {
    assertData(address);
    const response = await axios.post(`${addressUrl}`, address);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};

export const updateAddress = async ({ id, ...address }) => {
  try {
    assertId(id);
    const response = await axios.put(`${addressUrl}/${encodeURIComponent(id)}`, address);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};

export const deleteAddress = async ({ id }) => {
  try {
    assertId(id);
    const response = await axios.delete(`${addressUrl}/${encodeURIComponent(id)}`);
    return response.data;
  } catch (err) {
    err.response = null;
    throw err;
  }
};
